import './App.css';
import TicTacToe from './Components/TicTacToe/TicTacToe';


function App() {
  return (
    <div className="App">
      <TicTacToe />
    </div>
  );
}

export default App;
